export var VERSION = '1.9.0';
//# sourceMappingURL=version.js.map